import { render, staticRenderFns } from "./PreparedSentMessagesSearch.vue?vue&type=template&id=554391aa&"
import script from "./PreparedSentMessagesSearch.vue?vue&type=script&lang=js&"
export * from "./PreparedSentMessagesSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports